export default {"src":"/polygon/_next/static/media/zerion.0af9563a.svg","height":1024,"width":1024};